export const getRequestPay = ({ addError }) => async (id: string): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/request-pay/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: any = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/modules/hr-requests/pays/_requestsPayActions.ts